function getWpNonce() {
    return window.bajantubeMusic?.nonce || window.wpApiSettings?.nonce || '';
}

async function apiFetch(path, options = {}) {
    const response = await fetch(`${window.bajantubeMusic.restUrl}${path}`, {
        ...options,
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': getWpNonce(),
            ...(options.headers || {}),
        },
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(data?.message || 'Request failed.');
    }

    return data;
}

export function acceptGiveawayEligibility(firstName, lastName, ageConfirmed, termsAccepted) {
    return apiFetch('/giveaway/eligibility', {
        method: 'POST',
        body: JSON.stringify({
            firstName,
            lastName,
            ageConfirmed: !!ageConfirmed,
            termsAccepted: !!termsAccepted,
        }),
    });
}

export function getGiveawayMe() {
    return apiFetch('/giveaway/me');
}

export function getGiveawayClaims() {
    return apiFetch('/giveaway/claims');
}

export function getActiveGiveawayTokens() {
    return apiFetch('/giveaway/tokens/active');
}

export function startGiveawayLogin(email) {
    return apiFetch('/giveaway/auth/start', {
        method: 'POST',
        body: JSON.stringify({ email }),
    });
}

export function verifyGiveawayLogin(email, code) {
    return apiFetch('/giveaway/auth/verify', {
        method: 'POST',
        body: JSON.stringify({ email, code }),
    });
}

export function claimPendingGiveaway(pendingClaimId) {
    return apiFetch('/giveaway/claim-pending', {
        method: 'POST',
        body: JSON.stringify({
            pending_claim_id: pendingClaimId,
        }),
    });
}

export function claimGiveawayToken(claimToken) {
    return apiFetch('/giveaway/tokens/claim', {
        method: 'POST',
        body: JSON.stringify({ claim_token: claimToken }),
    });
}

export function getGiveawayPlacements() {
    return apiFetch('/giveaway/placements');
}

export function requestTrackOfTheDayReward(trackId, listenEventId = '') {
    return apiFetch('/giveaway/reward/track-of-the-day', {
        method: 'POST',
        body: JSON.stringify({
            track_id: trackId,
            listen_event_id: listenEventId,
        }),
    });
}

export function requestSlotReward(slot, sourceType, tokenId = 0) {
    return apiFetch('/giveaway/reward/slot', {
        method: 'POST',
        body: JSON.stringify({
            slot,
            source_type: sourceType,
            token_id: tokenId,
        }),
    });
}

export function getCurrentGiveaway() {
    return apiFetch('/giveaway/current');
}

export function getGiveawayProfile() {
    return apiFetch('/giveaway/claims');
}
